module.exports = __webpack_public_path__ + "static/media/icon-neutral.a65f5276.svg";